import configureLoginServices from './login-services';
import configureRequirementServices from './requirement-services';

export default () => [...configureRequirementServices(), ...configureLoginServices()];
